import { EnvironmentConfig } from '@/backend/extraTypes';
import { GlobalAppPropsHeader } from '@juvare/common-web-ui/GlobalApp/types';

export function getGlobalHeaderEnvironment(config: EnvironmentConfig): GlobalAppPropsHeader['environment'] {
    switch (config.environment) {
        case 'local':
        case 'dev':
        case 'lab':
        case 'demo':
            return config.environment;
        default:
            return undefined;
    }
}
